export default __webpack_public_path__ + "static/media/Salient Features_USHPP_3.113ddd76.jpg";